var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "linkedin",
    d: "M0,2.149A2.176,2.176,0,0,1,2.2,0H27.8A2.176,2.176,0,0,1,30,2.149v25.7A2.176,2.176,0,0,1,27.8,30H2.2A2.176,2.176,0,0,1,0,27.851ZM9.268,25.114V11.567h-4.5V25.114Zm-2.25-15.4a2.347,2.347,0,1,0,.03-4.68,2.346,2.346,0,1,0-.06,4.68Zm9.2,15.4V17.548a3.057,3.057,0,0,1,.15-1.1,2.463,2.463,0,0,1,2.31-1.646c1.629,0,2.28,1.241,2.28,3.064v7.247h4.5v-7.77c0-4.163-2.22-6.1-5.183-6.1a4.473,4.473,0,0,0-4.059,2.237v.047h-.03l.03-.047V11.567h-4.5c.056,1.271,0,13.547,0,13.547Z",
    fill: "#142454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.78de0535657c2fecc0f2c4f46e863036.svg";
export { ForwardRef as ReactComponent };